export function createReplayerKeyboardHandlers(deps) {
  const d = {
    ...deps,
    onPlayPause: () => deps.playPause.click(),
    onToggleFullscreen: () => deps.btnFs.click(),
    onFollowPrev: () => {
      if (deps.followOrder.length <= 1) return
      deps.followPrev.click()
    },
    onFollowNext: () => {
      if (deps.followOrder.length <= 1) return
      deps.followNext.click()
    }
  }

  let momentaryArrow = null
  let savedPlayback = null

  function disarmMomentaryScan() {
    if (!momentaryArrow) return
    const s = savedPlayback
    momentaryArrow = null
    savedPlayback = null

    if (!s.playing) {
      d.replayLoop.pausePlayback()
    } else {
      d.replayLoop.playing = true
      d.replayLoop.speedMode = s.speedMode
      d.replayLoop.playAccumulator = s.playAccumulator
      d.btnRewind.setAttribute('aria-pressed', s.speedMode === 'rw2' ? 'true' : 'false')
      d.btnFf.setAttribute('aria-pressed', s.speedMode === 'ff2' ? 'true' : 'false')
      d.replayLoop.resetLastFrameMs()
      d.replayLoop.scheduleFrame()
      d.updateTransportButton()
    }
  }

  async function armMomentaryScan(direction) {
    const isRw = direction === 'left'
    if (isRw && d.playback.appliedSteps <= 0) return
    if (!isRw && d.playback.appliedSteps >= d.duration) return
    if (momentaryArrow) return

    savedPlayback = {
      playing: d.replayLoop.playing,
      speedMode: d.replayLoop.speedMode,
      playAccumulator: d.replayLoop.playAccumulator
    }
    momentaryArrow = isRw ? 'left' : 'right'

    d.replayLoop.speedMode = isRw ? 'rw2' : 'ff2'
    d.replayLoop.playAccumulator = 0
    d.btnRewind.setAttribute('aria-pressed', isRw ? 'true' : 'false')
    d.btnFf.setAttribute('aria-pressed', isRw ? 'false' : 'true')

    if (!d.replayLoop.playing) {
      await d.audio.resume()
      d.audio.setThruster(false)
      d.replayLoop.playing = true
    }
    d.replayLoop.resetLastFrameMs()
    d.replayLoop.scheduleFrame()
    d.updateTransportButton()
  }

  const routes = [
    { match: e => e.key === ' ' || e.code === 'Space', go: () => d.onPlayPause() },
    { match: e => e.key === 'f' || e.key === 'F', go: () => d.onToggleFullscreen() },
    { match: e => e.key === ',' || e.key === '<', go: () => d.stepFrameBack() },
    { match: e => e.key === '.' || e.key === '>', go: () => d.stepFrameForward() },
    { match: e => e.key === 'a' || e.key === 'A', go: () => d.onFollowPrev() },
    { match: e => e.key === 'd' || e.key === 'D', go: () => d.onFollowNext() }
  ]

  function keydown(e) {
    if (!d.dialog.matches(':popover-open') || e.key === 'Escape') return

    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      if (e.repeat) return
      e.preventDefault()
      e.stopImmediatePropagation()
      void armMomentaryScan(e.key === 'ArrowLeft' ? 'left' : 'right')
      return
    }

    for (const { match, go } of routes) {
      if (!match(e)) continue
      e.preventDefault()
      e.stopImmediatePropagation()
      go()
      return
    }
  }

  function keyup(e) {
    if (!d.dialog.matches(':popover-open')) return
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return
    const dir = e.key === 'ArrowLeft' ? 'left' : 'right'
    if (momentaryArrow !== dir) return
    e.preventDefault()
    e.stopImmediatePropagation()
    disarmMomentaryScan()
  }

  function blur() {
    disarmMomentaryScan()
  }

  return { keydown, keyup, blur }
}
